import React, { Fragment, useEffect, useState, useContext } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { Context } from '../context';
import { MainLayout } from './MainLayout';
import { LayoutGrid } from './LayoutGrid';
import { Password } from './Password';
import { Alumni } from './Alumni';
import { Project } from './Project';
import Main from './Main';
import { AlumniMeta } from './AlumniMeta';
import { SubscribeSalesforce } from './SubscribeSalesforce';
import { Layout } from 'antd';


export function RoutesMain(props) {

  const context = useContext(Context);


  return (


      <Router>
        <Routes>



          <Route
            exact path="/"
            element={<>
              <MainLayout page="main">
                <Password />
                <Main />
              </MainLayout>
            </>
            }
          />

          <Route
            exact path="/portfolios"
            element={<>
              <MainLayout>
                <Password />
                <LayoutGrid />
              </MainLayout>
            </>
            }
          />

          <Route
            exact path="/:alumni"
            element={<>
              <AlumniMeta />
              <MainLayout>
                <Password />
                <Alumni />
              </MainLayout>
            </>
            }
          />

              <Route
                  exact path="/subscribe"
                  element={<>
                      <Layout className='b content' style={{ position: 'relative' }}>
                          <SubscribeSalesforce />
                      </Layout>
                  </>
                  }
              />

          <Route
            exact path="/:alumni/:project"
            element={<>
              <MainLayout>
                <Password />
                <Project />
              </MainLayout>
            </>
            }
          />



        </Routes>

      {/* <img src="https://app.netlify.com/access-control/bb-api/api/v1/badges/4cc4bc09-3e55-4e95-a81f-c4af42413728/deploy-status" alt="Deploy status badge" height={20} /> */}

      </Router>


  )
}